module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/our_services_1-40e7e3bbe5262d6cbfde588763208452.jpg";